/**
 * AUTORE – single, real Kiwi Size Chart link, placed below variant selectors.
 * Moves the original app-owned element rather than creating a synthetic trigger.
 * Leaves it untouched if unavailable or Kiwi uses unexpected markup.
 */
(() => {
  "use strict";
  if (window.__autoreKiwiChartPlacementLoaded) return;
  window.__autoreKiwiChartPlacementLoaded = true;

  const start = () => {
    const zone = document.querySelector(".autore-pdp-compact .autore-kiwi-size-zone");
    if (!zone) return;
    const slot = zone.querySelector("[data-autore-kiwi-slot]");
    if (!slot) return;

    const panel = zone.closest(".product-column-right") || zone.closest(".autore-pdp-compact") || document.body;
    const sourceSelector = ".ks-chart-container, .sizing-chart-container, .ks-container-with-modal";
    const modalLinkSelector = ".ks-chart-modal-link, .ks-recommender-modal-link";

    function relocate() {
      if (!zone.isConnected) return;
      const existing = slot.querySelector(modalLinkSelector);
      if (existing) {
        zone.hidden = false;
        return;
      }

      const candidates = panel.querySelectorAll(sourceSelector);
      for (const candidate of candidates) {
        if (slot.contains(candidate)) continue;
        if (candidate.closest("dialog, [role='dialog'], .ks-chart-modal, .ks-size-chart-modal")) continue;
        if (!candidate.matches(modalLinkSelector) && !candidate.querySelector(modalLinkSelector)) continue;
        // Move the exact app element; DOM event handlers remain on the same nodes.
        slot.appendChild(candidate);
        zone.hidden = false;
        // Localize visible text without replacing the app trigger or its listeners.
        const link = slot.querySelector(".ks-chart-modal-link");
        if (link && link.textContent.includes("Size Chart")) {
          const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            if (node.nodeValue && node.nodeValue.includes("Size Chart")) {
              node.nodeValue = node.nodeValue.replace("Size Chart", "Guida alle taglie");
            }
          }
        }
        return;
      }
    }

    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(() => {
        scheduled = false;
        relocate();
      });
    });

    observer.observe(panel, { childList: true, subtree: true });
    relocate();
    document.addEventListener("shopify:section:load", relocate);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
